interface Props {
  text: string;
}

export default function Badge({ text }: Props) {
  return (
    <span className="py-0.5 px-1 border border-green-300 rounded-md bg-green-100 text-[10px] font-normal text-green-500">{text}</span>
  );
}
